<template>
  <c-model ref="downLoadModel" :title="title" width="60%" @confirm="downLoadSubmit">
    <el-form ref="downLoadForm" :model="downLoadInfo">
      <el-form-item label="请选择考点:" prop="examAddressId" required hiddenErrorText>
        <el-select v-model="downLoadInfo.examAddressId " placeholder="请选择考点">
          <el-option
            v-for="(item,index) in addressList"
            :key="index"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
      </el-form-item>
      <slot name="other"></slot>
    </el-form>
  </c-model>
</template>

<script>
export default {
  props: {
    title: String,
    addressList: {
      type: Array,
      default: () => []
    }
  },
  data() {
    return {
      formData: null,
      downLoadInfo: {
        examAddressId: null
      }
    };
  },
  methods: {
    open() {
      this.downLoadInfo.examAddressId = null
      this.$refs.downLoadModel.open();
    },
    close() {
      this.$refs.downLoadModel.close();
      
      //清空文件
      this.fileList = [];
      this.formData = null;
    },
    downLoadSubmit() {
      this.$refs.downLoadForm.validate(valid => {
        if (valid) {
          const { downLoadInfo } = this;
          this.$emit("finished", downLoadInfo);
          this.$refs.downLoadModel.close();
        }
      });
    }
  }
};
</script>

<style lang="scss">
.other_content {
  margin-bottom: 20px;
  //   border-bottom: 1px solid #eee;
  padding-bottom: 20px;
}
.upload_content {
  overflow: hidden;
  margin :global {
    .el-upload__tip {
      color: #999;
    }
  }
}
.custom_class {
  float: left !important;
}
</style>
